import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal, RevealWords, Overline } from "./shared";
import { services } from "../data/services";

export default function Services() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative mx-auto max-w-7xl px-6 py-16 md:py-24"
    >
      <div className="mb-12 max-w-2xl">
        <Reveal>
          <Overline>What we do</Overline>
        </Reveal>
        <RevealWords
          text="Services engineered to move you forward"
          className="font-display mt-5 text-4xl font-semibold leading-tight text-white md:text-5xl"
        />
      </div>

      <div className="grid grid-cols-1 gap-6 md:grid-cols-12">
        {services.map((s, i) => {
          const Icon = s.icon;
          return (
            <Reveal key={s.slug} delay={i * 0.06} className={s.span}>
              <motion.div
                whileHover={{ y: -8 }}
                transition={{ type: "spring", stiffness: 250, damping: 20 }}
                className="h-full"
              >
                <Link
                  to={`/services/${s.slug}`}
                  data-testid={`service-card-${i}`}
                  className="group relative flex h-full min-h-[240px] flex-col overflow-hidden rounded-3xl border border-white/10 bg-[#0d0e15] p-8 transition-colors hover:border-[#00f0ff]/50"
                >
                  <img
                    src={s.img}
                    alt={s.title}
                    className="animate-kenburns absolute inset-0 h-full w-full object-cover opacity-20 transition-opacity duration-500 group-hover:opacity-30"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0d0e15] via-[#0d0e15]/85 to-[#0d0e15]/40" />
                  <div className="relative z-10 flex h-full flex-col">
                    <div className="mb-6 inline-flex h-14 w-14 items-center justify-center rounded-2xl border border-white/10 bg-white/5 text-[#00f0ff] transition-all group-hover:scale-110 group-hover:text-[#b026ff]">
                      <Icon className="h-7 w-7" />
                    </div>
                    <h3 className="font-display text-2xl text-white">{s.title}</h3>
                    <p className="mt-3 max-w-md text-sm leading-relaxed text-[#a0aec0]">
                      {s.short}
                    </p>
                    <span className="mt-auto flex items-center gap-1.5 pt-5 font-mono-tech text-xs uppercase tracking-widest text-[#00f0ff] opacity-0 transition-opacity duration-300 group-hover:opacity-100">
                      Learn more
                      <ArrowUpRight className="h-4 w-4" />
                    </span>
                  </div>
                  <div className="absolute -bottom-16 -right-16 h-40 w-40 rounded-full bg-[#b026ff]/20 blur-3xl opacity-0 transition-opacity duration-500 group-hover:opacity-100" />
                </Link>
              </motion.div>
            </Reveal>
          );
        })}
      </div>
    </section>
  );
}
